import { Typography, Box, Button, Tab, Tabs } from "@mui/material";
import Layout from "../../../components/Layout";
import styles from "../../index.module.scss";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import TableComponent from "../../../components/TableComponent";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState, appActions } from "../../../store/app";
import AddIcon from "@mui/icons-material/Add";
import Storage from "../../../utils/storage";
import LoadingContainer from "../../../components/LoadingContainer";
import { useTranslation } from "../../../i18n";
import PopupMenu from "../../../components/PopupMenu";
import ConfirmModal from "../../../components/ConfirmModal";
import { deleteAction } from "../../../store/app/appActions";
import SearchComponent from "../../../components/SearchComponent";
import ChipComponent, { ChipData } from "../../../components/ChipComponent";
import { LoadingButton } from "@mui/lab";
import AddFeeding from "./AddFeeding";
import FilterFeeding from "./FilterFeeding";
import FeedingView from "./FeedingView";
import { expensesActions, ExpensesState } from "../../../store/expenses";
import {
  Feeding,
  feedingColumns,
  FeedingRow,
} from "../../../interfaces/Expenses/feeding";
import { deleteFeedingService } from "../../../store/expenses/feeding/feedingService";
import {
  exportFeedingsAction,
  getFeedingsAction,
  searchFeedingAction,
} from "../../../store/expenses/feeding/feedingActions";
import Items from "../items/Items";

const Feedings = (props: any) => {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(50);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [query, setQuery] = useState("");
  const [isInit, setIsInit] = useState(true);
  const dispatch = useDispatch();
  const appState: AppState = useSelector((state: any) => state.app);
  const expensesState: ExpensesState = useSelector(
    (state: any) => state.expenses
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [chipData, setChipData] = useState([]);
  const [feeding, setFeeding] = useState<any>();
  const [viewFeeding, setViewFeeding] = useState<boolean>();
  const open = Boolean(anchorEl);
  const token = Storage.getToken();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    dispatch(
      getFeedingsAction(
        `?page=${page}&sort=-createdAt&limit=${rowsPerPage}`,
        token
      )
    );
  }, []);

  useEffect(() => {
    if (!expensesState.fetchedFeedings) {
      dispatch(
        getFeedingsAction(
          `?page=${page}&sort=-createdAt&limit=${rowsPerPage}${query}`,
          token
        )
      );
    }
  }, [
    dispatch,
    expensesState.fetchedFeedings,
    page,
    query,
    rowsPerPage,
    token,
  ]);

  useEffect(() => {
    if (!appState.isFetching) {
      setCount(appState.count);
    }
  }, [appState.isFetching, appState.count]);

  useEffect(() => {
    if (chipData.length > 0) {
      let queryString = "";
      chipData.forEach((data: any) => {
        queryString += `&${data.id}=${data.filter}`;
      });
      setQuery(queryString);
      dispatch(expensesActions.setFetchedFeedings(false));
    } else if (chipData.length === 0 && query !== "") {
      setQuery("");
      dispatch(expensesActions.setFetchedFeedings(false));
    }
  }, [chipData, dispatch, query]);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (searchText) {
        dispatch(searchFeedingAction(`?text=${searchText}`, token));
        setIsInit(false);
      } else {
        if (!appState.isFetching && !isInit) {
          dispatch(expensesActions.setFetchedFeedings(false));
        }
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [appState.isFetching, dispatch, isInit, searchText, token]);

  const createData = (feeding: Feeding): FeedingRow => {
    return {
      date: feeding?.date?.substring(0, 10),
      amount: feeding?.amount,
      action: (
        <button
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setFeeding(feeding);
            setAnchorEl(event.currentTarget);
          }}
          className={styles.actionsIcon}
        >
          •••
        </button>
      ),
    };
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
    dispatch(expensesActions.setFetchedFeedings(false));
  };

  const filterHandler = (filterData: any) => {
    setChipData(filterData);
  };

  const handleChipDelete = (chipToDelete: ChipData) => {
    setChipData((chips) =>
      chips.filter((chip: ChipData) => chip.key !== chipToDelete.key)
    );
  };

  const exportExcelHandler = () => {
    dispatch(exportFeedingsAction("?limit=1000", token, t("Feedings")));
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(expensesActions.setFetchedFeedings(false));
  };

  const deleteReproductionHandler = () => {
    dispatch(
      deleteAction(
        deleteFeedingService,
        feeding?._id,
        token,
        t("Feedings"),
        () => {},
        () => dispatch(expensesActions.setFetchedFeedings(false))
      )
    );
  };

  const rows = expensesState.feedings?.map((feeding: Feeding) =>
    createData(feeding)
  );

  return (
    <>
      <Box className={styles.topContainer}>
        <Box>{t("welcome")}</Box>

        <Box className={styles.dFlex}>
          <SearchComponent setSearchText={setSearchText} />
          <LoadingButton
            variant="contained"
            startIcon={<SaveAltIcon />}
            loading={appState.isExportingExcel}
            onClick={exportExcelHandler}
            className={styles.exportExcelButton}
          >
            {t("exportExcel")}
          </LoadingButton>
        </Box>
      </Box>
      {appState.isFetching && <LoadingContainer />}
      {!appState.isFetching && (
        <>
          {chipData.length > 0 && (
            <ChipComponent
              chipData={chipData}
              handleDelete={handleChipDelete}
            />
          )}
          <Box className={styles.tableTopActions}>
            <Box>
              <Typography>{t("Feedings")}</Typography>
            </Box>
            <Box>
              <Button
                onClick={() => dispatch(appActions.setOpenFilter(true))}
                startIcon={<AddIcon />}
              >
                {t("filter")}
              </Button>
              <Button
                onClick={() =>
                  dispatch(
                    appActions.setOpenForm({ open: true, action: "add" })
                  )
                }
                startIcon={<AddIcon />}
              >
                {t("addNew")}
              </Button>
            </Box>
          </Box>
          <TableComponent
            rows={rows}
            columns={feedingColumns}
            count={count}
            page={page}
            rowsPerPage={rowsPerPage}
            handlePageChange={handlePageChange}
            handleRowsPerPageChange={handleRowsPerPageChange}
          />
          {open && (
            <PopupMenu
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              onView={() => setViewFeeding(true)}
              onUpdate={() =>
                dispatch(
                  appActions.setOpenForm({ open: true, action: "update" })
                )
              }
              onDelete={() => dispatch(appActions.setIsDeleting(true))}
            />
          )}
          {appState.isDeleting && (
            <ConfirmModal
              onConfirm={() => deleteReproductionHandler()}
              content={`${t(
                "confirmDeleteDesc"
              )} urubyaro rw'inyangazi ifite iherena:  ${
                feeding?.reproduction?.sow?.earTag
              } ?`}
            />
          )}
          {appState.openForm.open && <AddFeeding feeding={feeding} />}
          {appState.openFilter && (
            <FilterFeeding
              open={appState.openFilter}
              close={() => dispatch(appActions.setOpenFilter(false))}
              filterHandler={filterHandler}
            />
          )}
          {viewFeeding && (
            <FeedingView
              open={viewFeeding}
              onClose={() => setViewFeeding(false)}
              feeding={feeding}
            />
          )}
        </>
      )}
    </>
  );
};

export default Feedings;
